 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTML02_SERIES_PAGE from '@/components/xhtml/02_Series_Page'
 import XHTML03_COPYRIGHT from '@/components/xhtml/03_Copyright'
 import XHTML04_EPIGRAPH from '@/components/xhtml/04_Epigraph'
 import XHTML05_TITLE_PAGE from '@/components/xhtml/05_Title_Page'
 import XHTML06_ANNOTATED_TABLE_OF_CONTENTS from '@/components/xhtml/06_ANNOTATED_TABLE_OF_CONTENTS'
 import XHTML07_EDITOR_S_NOTE from '@/components/xhtml/07_Editor_s_Note'
 import XHTML08_IVY_ALVAREZAUTO_BIOGRAPHY__OR_SO from '@/components/xhtml/08_IVY_ALVAREZAuto_biography__or_so'
 import XHTML09_PHILIP_BEIDLER_AMERICA_S_FAIRY_T from '@/components/xhtml/09_PHILIP_BEIDLER_America_s_Fairy_T'
 import XHTML10_MARGO_BERDESHEVSKY_WINDOW from '@/components/xhtml/10_MARGO_BERDESHEVSKY_Window'
 import XHTML11_ANN_FISHER_WIRTHVARIATIONS_ON_TH from '@/components/xhtml/11_ANN_FISHER_WIRTHVariations_on_th'
 import XHTML12_TONY_FRIEDHOFF_THREE_POEMS from '@/components/xhtml/12_TONY_FRIEDHOFF_Three_Poems'
 import XHTML13_ARIELLE_GREENBERGFOUR_POEMS from '@/components/xhtml/13_ARIELLE_GREENBERGFour_Poems'
 import XHTML14_EVAN_HARRISTHE_FUTURE_OF_DESPAIR from '@/components/xhtml/14_EVAN_HARRISThe_Future_of_Despair'
 import XHTML15_MC_HYLAND__BIRD__HOW_BEAUTIFULLY from '@/components/xhtml/15_MC_HYLAND__Bird__how_beautifully'
 import XHTML16_LESLEY_JENIKETHREE_ENTER_THE_DAR from '@/components/xhtml/16_LESLEY_JENIKEThree_Enter_the_Dar'
 import XHTML17_KAMILA_LISTWO_POEMS from '@/components/xhtml/17_KAMILA_LISTwo_Poems'
 import XHTML18_ASHLEY_MCWATERS_SEVEN_POEMS from '@/components/xhtml/18_ASHLEY_McWATERS_Seven_Poems'
 import XHTML19_BARBARA_JANE_REYESTHE_DUYONG_SER from '@/components/xhtml/19_BARBARA_JANE_REYESThe_Duyong_Ser'
 import XHTML20_TIMOTHY_SCHAFFERTTHE_YOUNG_WIDOW from '@/components/xhtml/20_TIMOTHY_SCHAFFERTThe_Young_Widow'
 import XHTML21_KURT_SCHWITTERS from '@/components/xhtml/21_KURT_SCHWITTERS'
 import XHTML22_KELLIE_WELLSRABBIT_CATCHER_OF_KI from '@/components/xhtml/22_KELLIE_WELLSRabbit_Catcher_of_Ki'
 import XHTML23_DARA_WIERTHE_WIZARD from '@/components/xhtml/23_DARA_WIERThe_Wizard'
 import XHTML24_IMANTS_ZIEDONIS from '@/components/xhtml/24_IMANTS_ZIEDONIS'
 import XHTML25_CONTRIBUTOR_NOTES from '@/components/xhtml/25_Contributor_Notes'
 import XHTML26_ACKNOWLEDGMENTS from '@/components/xhtml/26_Acknowledgments'
 import XHTML27_ANNOUNCEMENTS from '@/components/xhtml/27_Announcements'
 import XHTML28_THE_END from '@/components/xhtml/28_THE_END'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/06_ANNOTATED_TABLE_OF_CONTENTS",
 			"name" : "xhtml/06_ANNOTATED_TABLE_OF_CONTENTS",
 			"component" : XHTML06_ANNOTATED_TABLE_OF_CONTENTS
 		},
 		{
 			"path" : "/xhtml/07_Editor_s_Note",
 			"name" : "xhtml/07_Editor_s_Note",
 			"component" : XHTML07_EDITOR_S_NOTE
 		},
 		{
 			"path" : "/xhtml/08_IVY_ALVAREZAuto_biography__or_so",
 			"name" : "xhtml/08_IVY_ALVAREZAuto_biography__or_so",
 			"component" : XHTML08_IVY_ALVAREZAUTO_BIOGRAPHY__OR_SO
 		},
 		{
 			"path" : "/xhtml/09_PHILIP_BEIDLER_America_s_Fairy_T",
 			"name" : "xhtml/09_PHILIP_BEIDLER_America_s_Fairy_T",
 			"component" : XHTML09_PHILIP_BEIDLER_AMERICA_S_FAIRY_T
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js